import { Suspense, lazy } from 'react';
import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Lazy-loaded components with webpackChunkName "client-portal-app"
export const PortalLayout = Loader(
  lazy(
    () =>
      import(
        /* webpackChunkName: "client-portal-app" */ './PortalLayout'
      )
  )
);

export const PortalLoginPage = Loader(
  lazy(
    () =>
      import(
        /* webpackChunkName: "client-portal-app" */ './Auth/PortalLoginPage'
      )
  )
);

export const DashboardPage = Loader(
  lazy(
    () =>
      import(
        /* webpackChunkName: "client-portal-app" */ './Dashboard/DashboardPage'
      )
  )
);

export const JobsListPage = Loader(
  lazy(
    () =>
      import(
        /* webpackChunkName: "client-portal-app" */ './Jobs/JobsListPage'
      )
  )
);

export const JobDetailPage = Loader(
  lazy(
    () =>
      import(
        /* webpackChunkName: "client-portal-app" */ './Jobs/JobDetailPage'
      )
  )
);

export const DocumentVaultPage = Loader(
  lazy(
    () =>
      import(
        /* webpackChunkName: "client-portal-app" */ './Documents/DocumentVaultPage'
      )
  )
);

export const MessagesPage = Loader(
  lazy(
    () =>
      import(
        /* webpackChunkName: "client-portal-app" */ './Messages/MessagesPage'
      )
  )
);

export const ComplianceTimelinePage = Loader(
  lazy(
    () =>
      import(
        /* webpackChunkName: "client-portal-app" */ './Deadlines/ComplianceTimelinePage'
      )
  )
);

export const NotificationsPage = Loader(
  lazy(
    () =>
      import(
        /* webpackChunkName: "client-portal-app" */ './Notifications/NotificationsPage'
      )
  )
);

export const SettingsPage = Loader(
  lazy(
    () =>
      import(
        /* webpackChunkName: "client-portal-app" */ './Settings/SettingsPage'
      )
  )
);

// Route configuration
const portalRoutes = {
  path: 'portal',
  children: [
    {
      // Login page - no layout wrapper (uses BaseLayout from parent)
      path: 'login',
      element: <PortalLoginPage />
    },
    {
      // All authenticated portal routes wrapped in PortalLayout
      path: '',
      element: <PortalLayout />,
      children: [
        { path: '', element: <DashboardPage /> },
        { path: 'dashboard', element: <DashboardPage /> },
        { path: 'tasks', element: <JobsListPage /> },
        { path: 'tasks/:id', element: <JobDetailPage /> },
        // Documents route hidden per requirement
        // { path: 'documents', element: <DocumentVaultPage /> },
        { path: 'messages', element: <MessagesPage /> },
        { path: 'deadlines', element: <ComplianceTimelinePage /> },
        { path: 'notifications', element: <NotificationsPage /> },
        { path: 'settings', element: <SettingsPage /> }
      ]
    }
  ]
};

export default portalRoutes;
